import React, { useEffect, useState } from 'react';
import { Grid } from '@material-ui/core';

import InfoRequest from '../InfoRequest';
import VehicleTableAdd from 'app/components/ServicesForms/Licenses/commonComponents/VehicleTableAdd';
import { default as ItineraryAdd } from 'app/components/ServicesForms/Licenses/commonComponents/Itinerary';

import {
  clearItineraryListLicensesDuplicate,
  clearVehicleListToLicensesDuplicate,
} from 'app/utils/forms/services/licenses';

function Itinerary(props) {
  const { classes, values, setFieldValue, oldLicense } = props;

  const [vehicles, setVehicles] = useState([]);
  const [vehiclesOld, setVehiclesOld] = useState([]);
  
  const [itinerary, setItinerary] = useState([]);
  const [itineraryOld, setItineraryOld] = useState([]);

  useEffect(() => {
    const init = async () => {
      if (values.licencaVeiculos && values.licencaVeiculos.length > 0) {
        setVehicles(values.licencaVeiculos);
      } else {
        if (oldLicense?.licencaVeiculos) {
          const list = clearVehicleListToLicensesDuplicate(oldLicense?.licencaVeiculos);
          setVehicles(list);
          setFieldValue('licencaVeiculos', list);
        }
      }
      if (values.itinerario && values.itinerario.length > 0) {
        setItinerary(values.itinerario);
      } else {
        if (oldLicense?.itinerario) {
          const list = clearItineraryListLicensesDuplicate(oldLicense?.itinerario);
          setItinerary(list);
          setFieldValue('itinerario', list);
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [oldLicense]);

  const handleChangeLists = (list, type) => {
    // eslint-disable-next-line default-case
    switch (type) {
      case 'vehicles':
        setVehicles(list);
        setFieldValue('licencaVeiculos', list);
        break;
      case 'itinerary':
        setItinerary(list);
        setFieldValue('itinerario', list);
        break;
    }
  };
  
  useEffect(() => {
    const init = () => {
      if (oldLicense?.licencaVeiculos) {
        setVehiclesOld(oldLicense.licencaVeiculos);
      }
      if (oldLicense?.itinerario) {
        setItineraryOld(oldLicense.itinerario);
      }
    };
    init();
  }, [oldLicense]);

  return (
    <>
      <InfoRequest {...props} />

      <Grid item xs={12}>
        <h3 className={classes.greenTitle}>Informações NOVAS na licença</h3>
      </Grid>

      <Grid item xs={12}>
        <VehicleTableAdd
          {...props}
          classes={classes}
          oldVehicles={vehiclesOld}
          data={vehicles}
          setData={list => handleChangeLists(list, 'vehicles')}
        />
      </Grid>

      <Grid item xs={12}>
        <ItineraryAdd
          {...props}
          classes={classes}
          oldItinerary={itineraryOld}
          data={itinerary}
          setData={list => handleChangeLists(list, 'itinerary')}
        />
      </Grid>
    </>
  );
}

export default Itinerary;
